<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-12 09:41:48
 * @LastEditTime: 2026-05-15 15:14:45
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 欠款供应清单审批
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/supplyManagement/debtSupplyDetailApproval.vue
-->
<template>
    <div class="flows-content">
        <el-container>
            <el-main style="margin-bottom: 20px; padding: 0;">
                <el-container direction="vertical">
                    <FlowHeader :isReadOnly="readOnly" :saveStatus="false" @saveSubmit="handleSubmit(1)"
                        @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)"
                        @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)"
                        @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)"
                        @handleCollection="handleSubmit(10)" />
                    <el-main class="info">
                        <div>
                            <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                                placeholder="请输入流程标题"></el-input>
                        </div>
                        <div class="info-top">
                            <div class="left">
                                <span>单据号码：{{ billCode }}</span>
                                <span class="text">制单日期：{{ billDate }}</span>
                            </div>
                            <div class="right">
                                <span>发起人：{{ applyPerson }}</span>
                                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
                            </div>
                        </div>
                        <div style="margin-top:20px;" class="table">
                            <el-descriptions :column="3" border class="descriptions" label-width="200">
                                <el-descriptions-item label="日期：" :span="3">{{ formData.dataMouth }}</el-descriptions-item>
                                <el-descriptions-item label="工程名称：" :span="3">{{ formData.engineeringName
                                }}</el-descriptions-item>
                                <el-descriptions-item label="财务编码：">{{ formData.financialCode }}</el-descriptions-item>
                                <el-descriptions-item label="合同单位：">{{ formData.contractUnit }}</el-descriptions-item>
                                <el-descriptions-item label="施工进度：">{{ formData.constructionProgress
                                }}</el-descriptions-item>
                                <el-descriptions-item label="本期项目产值(万元)：">{{ decimal.div(formData.currentProjectOutputValue * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="本期合同应收款(万元)：">{{ decimal.div(formData.currentContractReceivables * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="本期累计回款(万元)：">{{ decimal.div(formData.currentCumulativePaymentReceived * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="本期工程欠款(万元)：">{{ decimal.div(formData.currentEngineeringArrears * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="本期合同欠款(万元)：">{{ decimal.div(formData.currentContractArrears * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="剩余量：">{{ formData.remainingQuantity }}</el-descriptions-item>
                                <el-descriptions-item label="是否联营项目：">{{ formData.whetherJointVentureProject == 0 ? '否' :
                                    '是' }}</el-descriptions-item>
                                <el-descriptions-item label="合同支付约定：" contentClassName="textClass2">{{
                                    formData.contractPaymentAgreement }}
                                </el-descriptions-item>
                                <el-descriptions-item label="最近一次付款时间：">{{ formData.lastPaymentTime
                                }}</el-descriptions-item>
                                <el-descriptions-item label="合同关于停供如何约定：" label-width="400" :span="2">{{
                                    formData.suspensionAgreement }}
                                </el-descriptions-item>
                                <el-descriptions-item label="我司是否发函：">{{ formData.whetherSendLetter == 0 ? '否' :
                                    '是' }}</el-descriptions-item>
                                <el-descriptions-item label="其他需要说明的事项：" :span="3">{{ formData.otherExplanatoryMatters }}
                                </el-descriptions-item>
                                <el-descriptions-item label="上期合同应收款(万元)：">{{ decimal.div(formData.lastContractReceivables * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="解控时累计回款(万元)：">{{ decimal.div(formData.realTimeCumulativeReal * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="实时累计回款(万元)（实时查询）：">{{ decimal.div(formData.newRealTimeCumulativeReal * 1 || 0,
                        10000)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="偏差率（%）X：">{{ decimal.mul(formData.latestDeviationRateX || 0,
                                    100)
                                }}</el-descriptions-item>
                                <el-descriptions-item label="合同欠款绝对额Y：">{{ formData.latestContractArrearsAbsValue
                                }}</el-descriptions-item>
                                <el-descriptions-item label="备注：">{{ formData.applyRemark }}
                                </el-descriptions-item>
                                <el-descriptions-item label="附件：" :span="3">
                                    <FileComponent fileCode="settlementFile" :disabled="true" :files="files" />
                                </el-descriptions-item>
                                <el-descriptions-item label="合同文本：" :span="3">
                                    <FileComponent fileCode="settlementFile" :disabled="true" :files="files3" />
                                </el-descriptions-item>

                            </el-descriptions>
                            <el-descriptions :column="3" border class="descriptions" label-width="200"
                                style="margin-bottom: 24px;">
                                <el-descriptions-item label="供应截止时间：" labelClassName="redFont">{{
                                    formData.controlDeadlineTime }}
                                </el-descriptions-item>
                                <el-descriptions-item label="本次限量：" labelClassName="redFont">{{ formData.controlQuantity }}
                                </el-descriptions-item>
                                <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">{{
                                    formData.distributionMeasures }}
                                </el-descriptions-item>
                            </el-descriptions>
                            <span v-if="taskType != 1" style="font-size: 18px">领导审批参数</span>
                            <el-button style="margin-left: 24px" size="medium"
                                :class="confirmStatus ? 'bottom_all' : 'bottom_two'" @click="confirmStatus = true">{{
                                    confirmStatus ? '已确认' : '请确认' }}</el-button>
                            <el-descriptions v-if="taskType != 1" :column="3" border class="descriptions" label-width="200"
                                style="margin-bottom: 24px;margin-top:12px">
                                <el-descriptions-item label="供应截止时间：" labelClassName="redFont">
                                    <el-date-picker v-model="formData.approvalControlDeadlineTime" style="width: 150px;"
                                        type="date" unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                                </el-descriptions-item>
                                <el-descriptions-item label="本次限量：" labelClassName="redFont">
                                    <el-input v-model="formData.approvalControlQuantity" type="number" placeholder="请输入"
                                        style="width: 150px;">
                                    </el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">
                                    <el-input v-model="formData.approvalDistributionMeasures" placeholder="请输入"
                                        style="width: 150px;">
                                    </el-input>
                                </el-descriptions-item>
                            </el-descriptions>
                            <span style="font-size: 18px">历史申请流程</span>
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%;margin-top: 12px;" tooltip-effect="dark
        " :data="formData.debtSupplyDetailHistoryList">
                                <el-table-column label="申请时间" align="center" prop="createTime"></el-table-column>
                                <el-table-column label="申请人" align="center" prop="createUserName"></el-table-column>
                                <el-table-column label="偏差率" align="center" prop="latestDeviationRateX">
                                    <template slot-scope="scope">
                                        {{ decimal.mul(scope.row.latestDeviationRateX || 0, 100) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="合同欠款绝对额" align="center"
                                    prop="latestContractArrearsAbsValue"></el-table-column>
                                <el-table-column label="分部措施" align="center" prop="distributionMeasures"></el-table-column>
                                <el-table-column label="本次限量" align="center" prop="controlQuantity"></el-table-column>
                                <el-table-column label="管控时间" align="center" prop="controlDeadlineTime"></el-table-column>
                                <el-table-column label="流程完成时间" align="center" prop="updateTime"></el-table-column>
                                <el-table-column label="操作" align="left">
                                    <template slot-scope="scope">
                                        <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                            查看
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="flows-details">
                            <FlowContent ref="flowcontent" :title='title' :dataForm="formData"
                                :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode"
                                @sendProcessManagerId="sendProcessManagerId" @sendProcessVersionId="sendProcessVersionId"
                                @handleFinish="handleFinish" @handleBusiness="handleBusiness"
                                @resetFlowState="resetFlowState" />
                        </div>
                    </el-main>
                </el-container>
                <!-- 历史记录明细 -->
                <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
                    <span slot="title" class="dialog-title">申请解控</span>
                    <el-descriptions :column="3" border class="descriptions" label-width="200">
                        <el-descriptions-item label="日期：" :span="3">{{ historyDetailForm.dataMouth }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称：" :span="3">{{ historyDetailForm.engineeringName
                        }}</el-descriptions-item>
                        <el-descriptions-item label="财务编码：">{{ historyDetailForm.financialCode }}</el-descriptions-item>
                        <el-descriptions-item label="合同单位：">{{ historyDetailForm.contractUnit }}</el-descriptions-item>
                        <el-descriptions-item label="施工进度：">{{ historyDetailForm.constructionProgress
                        }}</el-descriptions-item>
                        <el-descriptions-item label="本期项目产值(万元)：">{{ decimal.div(historyDetailForm.currentProjectOutputValue * 1 || 0,
                        10000) 
                        }}</el-descriptions-item>
                        <el-descriptions-item label="本期合同应收款(万元)：">{{ decimal.div(historyDetailForm.currentContractReceivables * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="本期累计回款(万元)：">{{ decimal.div(historyDetailForm.currentCumulativePaymentReceived * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="本期工程欠款(万元)：">{{ decimal.div(historyDetailForm.currentEngineeringArrears * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="本期合同欠款(万元)：">{{ decimal.div(historyDetailForm.currentContractArrears * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="剩余量：">{{ historyDetailForm.remainingQuantity }}</el-descriptions-item>
                        <el-descriptions-item label="是否联营项目：">{{ historyDetailForm.whetherJointVentureProject == 0 ? '否' :
                            '是' }}</el-descriptions-item>
                        <el-descriptions-item label="合同支付约定：" contentClassName="textClass2">{{
                            historyDetailForm.contractPaymentAgreement }}
                        </el-descriptions-item>
                        <el-descriptions-item label="最近一次付款时间：">{{ historyDetailForm.lastPaymentTime
                        }}</el-descriptions-item>
                        <el-descriptions-item label="合同关于停供如何约定：" label-width="400" :span="2">{{
                            historyDetailForm.suspensionAgreement }}
                        </el-descriptions-item>
                        <el-descriptions-item label="我司是否发函：">{{ historyDetailForm.whetherSendLetter == 0 ? '否' :
                            '是' }}</el-descriptions-item>
                        <el-descriptions-item label="其他需要说明的事项：" :span="3">{{ historyDetailForm.otherExplanatoryMatters }}
                        </el-descriptions-item>
                        <el-descriptions-item label="上期合同应收款(万元)：">{{ decimal.div(historyDetailForm.lastContractReceivables * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="解控时累计回款(万元)：" labelClassName="redFont">{{
                            decimal.div(historyDetailForm.realTimeCumulativeReal * 1 || 0,
                        10000)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="偏差率（%）X：">{{ decimal.mul( historyDetailForm.deviationRateX || 0, 100) 
                        }}</el-descriptions-item>
                        <el-descriptions-item label="合同欠款绝对额Y：">{{ historyDetailForm.contractArrearsAbsValue
                        }}</el-descriptions-item>
                        <el-descriptions-item label="备注：" :span="3">{{ historyDetailForm.applyRemark }}
                        </el-descriptions-item>
                        <el-descriptions-item label="附件：" :span="3">
                            <FileComponent fileCode="settlementFile" :disabled="true" :files="files2" />
                        </el-descriptions-item>
                        <el-descriptions-item label="合同文本：" :span="3">
                            <FileComponent fileCode="settlementFile" :disabled="true" :files="files4" />
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions :column="3" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                        <el-descriptions-item label="供应截止时间：" labelClassName="redFont">{{
                            historyDetailForm.controlDeadlineTime }}
                        </el-descriptions-item>
                        <el-descriptions-item label="本次限量：" labelClassName="redFont">{{ historyDetailForm.controlQuantity }}
                        </el-descriptions-item>
                        <el-descriptions-item label="分部措施：" labelClassName="redFont" contentClassName="textClass">{{
                            historyDetailForm.distributionMeasures }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <span style="font-size: 18px">领导审批参数</span>
                    <el-descriptions :column="3" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                        <el-descriptions-item label="供应截止时间：" labelClassName="redFont">{{
                            historyDetailForm.approvalControlDeadlineTime }}
                        </el-descriptions-item>
                        <el-descriptions-item label="本次限量：" labelClassName="redFont">
                            {{ historyDetailForm.approvalControlQuantity }}
                        </el-descriptions-item>
                        <el-descriptions-item label="分部措施：" labelClassName="redFont">
                            {{ historyDetailForm.approvalDistributionMeasures }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <FlowsNodeList :tableData="approveTableData" />
                    <span slot="footer" class="dialog-footer">
                        <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                    </span>
                </el-dialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { approvalUpdateDetail, applyTerminatedControl, approvalCallback, queryHistoryById, updateHistoryById,queryHistoryList } from "@/api/internetSales/supplyManagement.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { getNodeList } from '@/api/task/flows';
import { backlogQueryByReceiptNumber } from '@/api/index';
import { safeDecodeURI } from "@/utils/utils.js";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
export default {
    components: {
        FlowContent,
        FlowHeader,
        FileComponent,
        FlowsNodeList
    },
    data() {
        return {
            type: 0,
            title: '解控申请单',
            billCode: '',
            billDate: '',
            taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
            applyPerson: '',
            taskStatus: 0,
            showSendVisible: false,
            readOnly: false,
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "80", fixed: "left", },
                { label: "财务编码", prop: "financialCode", status: true, width: "220", fixed: "left", },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left", },
                { label: "合同单位", prop: "contractUnit", status: true, width: "220" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "本期项目产值", prop: "currentProjectOutputValue", status: true, width: "100" },
                { label: "本期合同应收款", prop: "currentContractReceivables", status: true, width: "110" },
                { label: "本期累计回款", prop: "currentCumulativePaymentReceived", status: true, width: "100" },
                { label: "本期工程欠款", prop: "currentEngineeringArrears", status: true, width: "100" },
                { label: "本期合同欠款", prop: "currentContractArrears", status: true, width: "100" },
                { label: "上期合同应收款", prop: "lastContractReceivables", status: true, width: "100" },
                { label: "实时累计回款", prop: "realTimeCumulativeReal", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "deviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "contractArrearsAbsValue", status: true, width: "auto" },
                { label: "欠款管控等级", prop: "debtControlLevel", status: true, width: "auto" },
            ],
            formData: {},
            tableData: [],
            total: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                engineeringName: "",
                reviewId: "",
                whetherControl: 1,
            },
            files: [],
            historyDetailDig: false,
            historyDetailForm: {},
            files2: [],
            files3: [],
            files4: [],
            processManagerId: "",
            processVersionId: "",
            processTaskId: "",
            approveTableData: [],
            taskType: 1,
            confirmStatus: false,
        }
    },
    methods: {
        sendProcessManagerId(processManagerId) {
            this.processManagerId = processManagerId;
        },
        sendProcessVersionId(processVersionId) {
            console.log(processVersionId)
            this.processVersionId = processVersionId;
            console.log("processVersionId-----------------------" + processVersionId)
        },
        approvalUpdateDetail() {
            let obj = {
                id: this.formData.id,
                approvalControlQuantity: this.formData.approvalControlQuantity, //本次限量
                approvalControlDeadlineTime: this.formData.approvalControlDeadlineTime,//管控时间
                approvalDistributionMeasures: this.formData.approvalDistributionMeasures//管控措施
            }
            approvalUpdateDetail(obj)
        },
        //1 不通过  2撤销
        resetFlowState(type) {
            if (type == 1) {
                const params = {
                    process_success: {
                        url: '/icps/system/sign/cloudSell/debtSupply/approvalCallback',
                        data: {
                            id: this.formData.id,
                            approvalStatus: 1,
                        },
                        httpMethod: 'post',
                    },
                    process_failure: {
                        url: '/icps/system/sign/cloudSell/debtSupply/approvalCallback',
                        data: {
                            id: this.formData.id,
                            approvalStatus: 3,
                        },
                        httpMethod: 'post',
                    },
                }
                this.$refs.flowcontent.handleToFlow(params);
            }
            if (type == 2) {
                approvalCallback({
                    id: this.formData.id,
                    approvalStatus: 4,
                })
            }

            this.showSendVisible = false;
        },
        handleBusiness() {
            const params = {
                process_success: {
                    url: '/icps/system/sign/cloudSell/debtSupply/approvalCallback',
                    data: {
                        id: this.formData.id,
                        approvalStatus: 1,
                        approvalControlQuantity: this.formData.approvalControlQuantity, //本次限量
                        approvalControlDeadlineTime: this.formData.approvalControlDeadlineTime,//管控时间
                        approvalDistributionMeasures: this.formData.approvalDistributionMeasures//管控措施
                    },
                    httpMethod: 'post',
                },
                process_failure: {
                    url: '/icps/system/sign/cloudSell/debtSupply/approvalCallback',
                    data: {
                        id: this.formData.id,
                        approvalStatus: 3,
                        approvalControlQuantity: this.formData.approvalControlQuantity, //本次限量
                        approvalControlDeadlineTime: this.formData.approvalControlDeadlineTime,//管控时间
                        approvalDistributionMeasures: this.formData.approvalDistributionMeasures//管控措施
                    },
                    httpMethod: 'post',
                },
            }
            this.showSendVisible = false;
            this.$refs.flowcontent.handleToFlow(params);
        },
        /**
         * @Description: 
         * @Param: 1为保存时 status 为 processTaskId，2为最后提交/3 中间提交 时 status 为2 通过 为3不通过
         * @Author: wangwangwang
         * @param {*} type
         */
        handleFinish(type, status) {
            console.log(type, status)
            //审批过程中修改数据
            if (type == 1) {
                approvalCallback({
                    id: this.formData.id,
                    approvalStatus: 2,
                })
                updateHistoryById({
                    id: this.formData.id,
                    processManagerId: this.processManagerId,
                    processTaskId: status,
                    processVersionId: this.processVersionId,
                    receiptNumber: this.billCode,
                })
            }

            this.approvalUpdateDetail()
        },
        async handleSubmit(type) {
            if (this.taskType != 1 && !this.confirmStatus && type == 2) {
                this.$message.warning('请确认领导审批参数!')
                return
            }
            const { query } = this.$route;
            const queryData = JSON.parse(query.dataContent)
            if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 提交流程
                this.showSendVisible = true;
                return
            }
            if (this.taskType == 1) {
                let res = await applyTerminatedControl(this.formData)
                if (res.code == 1001) {
                    this.formData = res.data
                    this.formData['debtControlLevelOld'] = queryData.debtControlLevelOld
                    const data = {
                        dataSource: 'debtSupplyDetailApproval',
                        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
                    }
                    this.$refs.flowcontent.saveFlows(type, data);
                }
            } else {
                const data = {
                    dataSource: 'debtSupplyDetailApproval',
                    dataContent: JSON.stringify({ ...this.formData }), // 业务数据
                }
                this.$refs.flowcontent.saveFlows(type, data);
            }


        },
        handleCancel() {
            this.showSendVisible = false;
        },
        /**
         * @Description: 回显业务数据
         * @Param: 
         * @Author: wangwangwang
         */
        initFlowsData() {
            this.isReadOnly = true;
            const { query } = this.$route;
            console.log("initFlowsData2", query);
            // const { formData} = query;
            const data = JSON.parse(query.dataContent);
            console.log("🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ data:", data)
            this.formData = data;
            this.tableParam.reviewId = this.formData.id
            this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
            this.files3 = this.formData.contractText ? JSON.parse(this.formData.contractText) : []
        },
        initFlowsData2() {
            const { query } = this.$route;
            this.formData = safeDecodeURI(JSON.parse(query.dataContent));
            const data = safeDecodeURI(JSON.parse(query.dataContent));
            this.formData.surplusDate = this.formData.startTime + "-" + this.formData.endTime
            this.title = query.taskName;
            this.billCode = query.receiptNumber;
            this.applyPerson = query.createUserName;
            this.billDate = query.createTime;
            this.taskStatus = query.taskStatus;
            this.tableParam.reviewId = this.formData.id
            this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
            this.files3 = this.formData.contractText ? JSON.parse(this.formData.contractText) : []
            queryHistoryById({ id: this.formData.id }).then(res => {
                if (res.code == 1001) {
                    this.formData = res.data
                    this.formData['debtControlLevelOld'] = data.debtControlLevelOld
                    queryHistoryList({ id: this.formData.supplyDetailId }).then(res2 => {
                    if (res.code == 1001) {
                        this.$set(this.formData, 'debtSupplyDetailHistoryList', res2.data.debtSupplyDetailHistoryList);
                        // this.formData['debtSupplyDetailHistoryList'] = res2.data.debtSupplyDetailHistoryList
                    }
                })
                }
            })
            
            this.openWorkFlowInfo()
        },
        sendCode(code) {
            this.billCode = code;
        },
        handleFlowChat() {
            this.$refs.flowcontent.showFlowNode()
        },
        // 查看审批情况
        openWorkFlowInfo() {
            console.log('查看审批情况 ', this.billCode)
            if (this.billCode) {
                backlogQueryByReceiptNumber(this.billCode).then(res => {
                    if (res.code == 1001) {
                        if (res.data) {
                            let valData = res.data
                            this.taskStatus = valData.taskStatus
                            this.applyPerson = valData.createUserName
                            this.billDate = valData.createTime
                            if (this.taskStatus == 3 || this.taskStatus == 4 || this.taskStatus == 5) {
                                this.readOnly = true
                            }
                        }
                    }
                })
            }
        },
        //查看历史
        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            this.files4 = this.historyDetailForm.contractText ? JSON.parse(this.historyDetailForm.contractText) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approvalStatus: item.approvalStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;
                    console.log('approveTableData',this.approveTableData)
                    console.log('11111112222222222-----------------',this.approveTableData)

                }
            });
            this.historyDetailDig = true
        },
    },
    mounted() {
        const { query } = this.$route;
        this.taskType = query.type
        if (query.type == 1) {
            // 发起流程
            this.initFlowsData();
            this.title = '解控申请单-' + this.formData.engineeringName
            this.applyPerson = getUserInfo().userRealName;
            this.$refs.flowcontent.initBaseData("debtSupplyDetailApproval");
            this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            this.formData.createUserName = this.applyPerson;
            this.formData.createTime = this.billDate;
            return;
        }
        this.initFlowsData2();
        if (query.isReadOnly * 1 === 1) {
            this.readOnly = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.flows-details {
    margin-top: 20px;
}

.info {
    padding: 0 20px;
    background: #fff;

    .info-top {
        font-size: $font_size;
        color: #000000;
        @include discen_al;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px #e1e5ed solid;

        .left {
            @include discen_al;
        }

        .text {
            margin-left: 60px;
        }
    }
}

.nav_title {
    @include discen_al;
    align-items: flex-end;

    >div {
        width: 4px;
        height: 24px;
        background: $bg_color;
        margin-right: 10px;
    }

    i {
        margin-left: 5px;
    }

    color: $bg_color;
    font-size: 20px;
    font-weight: bold;
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}</style>